/** Normalize ChannelManagerEmail from Firestore (string, array, or comma-separated). */
export function parseChannelManagerEmails(
  value: string | string[] | undefined | null
): string[] {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value
      .map((email) => String(email).trim().toLowerCase())
      .filter(Boolean);
  }
  return String(value)
    .split(",")
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
}

export function isUserChannelManager(
  channel: { ChannelManagerEmail?: string | string[] },
  userEmail: string
): boolean {
  const normalizedUser = userEmail.trim().toLowerCase();
  if (!normalizedUser) {
    return false;
  }
  return parseChannelManagerEmails(channel.ChannelManagerEmail).includes(
    normalizedUser
  );
}

export function buildMyChannelIdSet(
  channels: Array<{ ChannelId: string; ChannelManagerEmail?: string | string[] }>,
  userEmail: string
): Set<string> {
  const ids = new Set<string>();
  for (const channel of channels) {
    if (channel.ChannelId && isUserChannelManager(channel, userEmail)) {
      ids.add(channel.ChannelId);
    }
  }
  return ids;
}

export function swapTouchesMyChannels(
  swap: { channelIDs?: string[] },
  myChannelIds: Set<string>
): boolean {
  if (myChannelIds.size === 0 || !swap.channelIDs?.length) {
    return false;
  }
  return swap.channelIDs.some((id) => myChannelIds.has(id));
}
